var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.NewUserCouponRewardDialog,{attrs:{"isShow":_setup.isCouponRewardDialogShow,"couponInfo":_setup.couponInfo},on:{"close":_setup.handleCloseRedeemCouponDialog,"redeemCoupon":_setup.handleRedeemCoupon,"viewCoupon":_setup.handleViewCouponInDialog}})
}
var staticRenderFns = []

export { render, staticRenderFns }